import type {ReactElement} from 'react';
import React from 'react';
import {createPortal} from 'react-dom';
import {PageControlBar} from '@Components/poster-editor/components/page-top-bar';
import {Page} from '@PosterWhiteboard/page/page.class';
import {useAppSelector} from '@/hooks';
import {PageSlider} from '@Components/poster-editor/components/page-slider/page-slider';

export function PageOptions(): ReactElement<any> {
  const pagesData = useAppSelector((state) => {
    return state.posterEditor.posterObject?.pages?.pagesHashMap;
  });

  const renderPageTopBar = (): null | ReactElement<any>[] => {
    const pageTopBars = [];

    if (!pagesData) {
      return null;
    }

    for (const [, page] of Object.entries(pagesData)) {
      const container = Page.getPageRightSideHtmlContainerForPageId(page.hashedID);
      const sliderContainer = Page.getPageBottomHtmlContainerForPageId(page.hashedID);
      if (container) {
        pageTopBars.push(createPortal(<PageControlBar pageId={page.hashedID} />, container));
      }

      if (sliderContainer) {
        pageTopBars.push(createPortal(<PageSlider pageId={page.hashedID} />, sliderContainer));
      }
    }

    return pageTopBars;
  };

  return <>{renderPageTopBar()}</>;
}
